import API from './API';

/* Handles major/minor page reload requests from the backend; see `eq hash` on
 * how to manipulate this. */

const HashService = (() => {
	var minor_latch = false;

	var hashes = {
		minor: undefined,
		major: undefined,
	};

	const change_handlers = {
		minor: () => {
			minor_latch = true;
		},

		major: () => {
			window.location.reload();
		},
	};

	var ping; ping = () => {
		API.get("/z/hashes", {}, (response, status) => {
			if (status >= 200 && status < 300) {
				for (const k in hashes) {
					if (hashes[k] !== undefined && response[k] !== hashes[k]) {
						change_handlers[k]();
					}
					hashes[k] = response[k];
				}

			}
			setTimeout(ping, 7500);
		});
	}
	ping();

	return {
		has_minor_change: () => {
			if (minor_latch) {
				minor_latch = false;
				return true;
			} else {
				return false;
			}
		}
	};
})();

export default HashService



// WEBPACK FOOTER //
// ./src/HashService.js